var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 50 50",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#c6b9c4;}.cls-3{fill:#ffffff;}.cls-4{fill:#d12200;}.cls-5{fill:#00a1d3;}.cls-6{fill:#ffba50;}.cls-7{fill:#8d7f89;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.608,35.717h-.14v-9.2a.5.5,0,0,0-.5-.5H35.8V17.223a.5.5,0,0,0-.5-.5H26a.5.5,0,0,0-.5.5v8.794H21.334a.5.5,0,0,0-.5.5v9.2H9.392a4.892,4.892,0,1,0,0,9.783H40.608a4.892,4.892,0,1,0,0-9.783Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.608,44.5H9.392a3.892,3.892,0,1,1,0-7.783H40.608a3.892,3.892,0,1,1,0,7.783Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.446,38.2a2.411,2.411,0,1,0,2.41,2.411A2.414,2.414,0,0,0,9.446,38.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.446,42.019a1.411,1.411,0,1,1,1.41-1.411A1.413,1.413,0,0,1,9.446,42.019Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.223,38.2a2.411,2.411,0,1,0,2.411,2.411A2.413,2.413,0,0,0,17.223,38.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.223,42.019a1.411,1.411,0,1,1,1.411-1.411A1.412,1.412,0,0,1,17.223,42.019Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,38.2a2.411,2.411,0,1,0,2.411,2.411A2.414,2.414,0,0,0,25,38.2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,42.019a1.411,1.411,0,1,1,1.411-1.411A1.413,1.413,0,0,1,25,42.019Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.777,38.2a2.411,2.411,0,1,0,2.411,2.411A2.414,2.414,0,0,0,32.777,38.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.777,42.019a1.411,1.411,0,1,1,1.411-1.411A1.413,1.413,0,0,1,32.777,42.019Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.554,38.2a2.411,2.411,0,1,0,2.411,2.411A2.413,2.413,0,0,0,40.554,38.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.554,42.019a1.411,1.411,0,1,1,1.411-1.411A1.412,1.412,0,0,1,40.554,42.019Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.468,35.717H31.14v-8.7h4.106a.54.54,0,0,0,.058.011c.02,0,.038-.009.058-.011h4.106Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.5,17.723H34.8v8.294H30.663l-.012,0-.011,0H26.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M21.834,27.017h4.107a.158.158,0,0,0,.116,0H30.14v8.7H21.834Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.765,11l-2.045-.288,1.243-1.651a.5.5,0,0,0-.046-.654L18.292,5.779a.5.5,0,0,0-.654-.046L15.987,6.977,15.7,4.93A.5.5,0,0,0,15.2,4.5H11.492a.5.5,0,0,0-.5.43l-.288,2.047L9.059,5.733a.5.5,0,0,0-.655.046L5.779,8.4a.5.5,0,0,0-.046.654l1.244,1.65L4.931,11a.5.5,0,0,0-.431.5V15.2a.5.5,0,0,0,.431.495l2.046.288L5.733,17.638a.5.5,0,0,0,.046.654L8.4,20.917a.5.5,0,0,0,.655.046l1.65-1.243L11,21.766a.5.5,0,0,0,.5.43H15.2a.5.5,0,0,0,.495-.43l.288-2.047,1.651,1.244a.5.5,0,0,0,.654-.046l2.625-2.625a.5.5,0,0,0,.046-.654L19.72,15.987l2.045-.288a.5.5,0,0,0,.43-.495V11.492A.5.5,0,0,0,21.765,11Zm-8.417,5.921a3.57,3.57,0,1,1,3.57-3.57A3.575,3.575,0,0,1,13.348,16.918Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M18.74,15.115,21.2,14.77V11.927l-2.455-.346a.5.5,0,0,1-.33-.8L19.9,8.8,17.893,6.793,15.911,8.286a.5.5,0,0,1-.8-.33L14.77,5.5H11.927l-.346,2.456a.5.5,0,0,1-.8.33L8.8,6.793,6.794,8.8l1.491,1.981a.5.5,0,0,1-.33.8L5.5,11.927V14.77l2.455.345a.5.5,0,0,1,.33.8L6.794,17.892,8.8,19.9l1.981-1.493a.5.5,0,0,1,.8.33l.346,2.456H14.77l.345-2.456a.5.5,0,0,1,.8-.33L17.893,19.9,19.9,17.892,18.41,15.911a.5.5,0,0,1,.33-.8Zm-5.392,1.8a3.57,3.57,0,1,1,3.57-3.57A3.575,3.575,0,0,1,13.348,16.918Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.348,8.778a4.57,4.57,0,1,0,4.57,4.57A4.575,4.575,0,0,0,13.348,8.778Zm0,8.14a3.57,3.57,0,1,1,3.57-3.57A3.575,3.575,0,0,1,13.348,16.918Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutput);
export default __webpack_public_path__ + "static/media/output.a61dbb54f7036a2bc7b7fa8c2b47a157.svg";
export { ForwardRef as ReactComponent };